// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1761 ? "d0deef33" : chunkId) + "." + {"1761":"6f799cb9bfd499e4","4995":"a622013436539179","8413":"58356e857214cb51"}[chunkId] + ".js";
};